
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M44.428 12.388H39.9V8.863a1 1 0 00-2 0v3.525H21.213V8.863a1 1 0 00-2 0v3.525h-4.529c-2.28 0-4.13 1.842-4.13 4.112v30.703c0 2.27 1.85 4.112 4.13 4.112h29.745c2.28 0 4.13-1.842 4.13-4.112V16.499a4.135 4.135 0 00-4.13-4.111zm-29.745 1.991h4.53v3.594a1 1 0 002 0v-3.594H37.9v3.594a1 1 0 002 0v-3.594h4.529c1.17 0 2.13.946 2.13 2.12v5.904H12.562V16.5a2.112 2.112 0 012.12-2.121zm29.745 34.935H14.683c-1.17 0-2.13-.946-2.13-2.121V24.394h33.995v22.799c0 1.165-.95 2.12-2.12 2.12z"}})])
          )
        }
      }
    